
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useTina } from "tinacms/dist/react";
import client from "../../../tina/__generated__/client";
import Post from "../../components/blog/BlogPost";
const NewsPage = (props) => {
    const { data } = useTina({
        query: props.query,
        variables: props.variables,
        data: props.data,
    });
    if (!data || !data.post) {
        return null;
    }
    return <Post {...data.post}/>;
};
export const getStaticPaths = async () => {
    const postConnection = await client.queries.postConnection();
    const basePaths = [];
    postConnection.data.postConnection.edges.forEach((post) => {
        const breadcrumbs = post.node._sys.breadcrumbs;
        const category = breadcrumbs[0];
        const filename = breadcrumbs[1];
        const categorySlug = post.node?.category?.slug;
        const locale = post.node.locale || "en";
        if ((category !== "news" && categorySlug !== "news") || !filename) {
            return;
        }
        basePaths.push({
            params: {
                slug: filename,
            },
            locale,
        });
    });
    return {
        paths: basePaths,
        fallback: true,
    };
};
const getStaticProps = async ({ params }) => {
    const { slug } = params;
    const variables = {
        relativePath: `news/${slug}.mdx`,
    };
    const props = await client.queries.post(variables);
    if (!props?.data?.post) {
        return {
            notFound: true,
        };
    }
    return {
        props: { ...props },
    };
};
export default NewsPage;

    async function __Next_Translate__getStaticProps__1a042aa3d82__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a042aa3d82__ as getStaticProps }
  